import React from 'react'
import './photo-section.css'

import Axios from 'axios'


const PhotoSection = (props) => {
    const [images, setImages] = React.useState([])
    const [imgData, setImgData] = React.useState({})
    const [noImages, setNoImages] = React.useState(false)
    const [selectedImg, setSelectedImg] = React.useState(false)
    const [wantToDelete, setWantToDelete] = React.useState(false)
    const [linkArray, setLinkArray] = React.useState([])
    
    React.useEffect(() => {
        if(props.links) {
            setLinkArray(props.links)
        }
        if(props.selectedPhoto !== '') {
            setSelectedImg(true)
        } else {
            document.getElementById('blog-photo-search').focus()
        }
    }, [])

    const callAPI = (text) => {
        Axios.get(`https://api.unsplash.com/search/photos?query=${text}`, {
            headers: {
                'Authorization': 'Client-ID DTVm6K6kbZwpy3q-lu_JMkLGhytzOqgHWydhmuzGRss'
            }
        })
        .then(res => {
            if(res.data.results.length === 0) {
                setNoImages(true)
            } else {
                setImages(res.data.results)
                setNoImages(false)
            }
        })
    }
    const handleKeyPress = (e) => {
        if(e.key === 'Enter') {
            callAPI(e.target.value)
        }
    }
    const pickAPhoto = (id, img) => {
        setImgData(img)
        setLinkArray([ `${img.user.links.html}?utm_source=pictures_for_blog&utm_medium=referral`, img.user.name])
        props.chooseAPhoto(id, img.urls.regular, [`${img.user.links.html}?utm_source=pictures_for_blog&utm_medium=referral`, img.user.name])
        setSelectedImg(true)
        Axios.get(img.links.download_location, {
            headers: {
                'Authorization': 'Client-ID DTVm6K6kbZwpy3q-lu_JMkLGhytzOqgHWydhmuzGRss'
            }
        })
        .then((res) => {
        })
        .catch((err) => {
            console.log(err)
        })
    }
    const deleteThePhoto = () => {
        props.deletePhoto(props.sectionId)
    }
    if(selectedImg) {
        return (
            <div className="blog-the-photo-wrapper">
                {wantToDelete && 
                    <div className="delete-overlay">
                        <h3 className="delete-image-prompt">Delete Image?</h3>
                        <div className="blog-btn-wrapper">
                            <div className="blog-btn" onClick={() => deleteThePhoto()}>Yes</div>
                            <div className="blog-btn" onClick={() => setWantToDelete(false)}>No</div>
                        </div>
                    </div>
                }
                <img className="selected-image" src={props.selectedPhoto} onClick={() => setWantToDelete(true)} />
                {props.links && <p>Photo by <a href={linkArray[0]} rel="noopener noreferrer" target="_blank">{linkArray[1]}</a> on <a href="https://unsplash.com/?utm_source=pictures_for_blog&utm_medium=referral" rel="noopener noreferrer" target="_blank">Unsplash</a></p>}
            </div>
        )
    } else {
        return(
            <div>
                <input className="blog-photo-search" id="blog-photo-search" placeholder="Type keywords to search Unsplash, and press Enter" onKeyPress={(e) => handleKeyPress(e)}/>
                <div className="blog-image-wrapper">
                    {images.map(image => <img className="suggested-pictures" src={image.urls.regular} onClick={() => pickAPhoto(props.sectionId, image)}/>)}
                    {noImages && <p>Sorry there are no images for {document.getElementById('blog-photo-search').value}</p>}
                </div>
            </div>
        )
    }
}
export default PhotoSection;